<template>
  <v-row class="ma-0 pa-0">
    <v-spacer></v-spacer>
    <v-col cols="11" class="ma-0 pa-0">
      <v-breadcrumbs :items="global.breadcrumbs.value" divider="/" density="compact" class="ma-0 pa-0 mb-0 mt-3">
      </v-breadcrumbs>
    </v-col>
    <v-spacer></v-spacer>
  </v-row>
</template>

<script setup>
const global = window.useGlobalStore();
</script>